import { hasRequiredFields } from '@move-frontend/utils';
import { useGuestBookingFormContext } from './useGuestBookingFormContext';

export function useHasRequiredFields() {
	const { watch } = useGuestBookingFormContext();
	const values = watch();

	return hasRequiredFields(values, ['reference', 'email']);
}
